// Backend job/candidate hrefs may be absolute (https://ats.example/jobs/21480)
// or root-relative (/jobs/21480). The app serves them as internal SPA routes,
// so reduce to the pathname before RouterLink/openFloatingBridge — a full URL
// in RouterLink `to` resolves against the current route and breaks
// (/agent/c/https://…). Falls back to the raw href if it can't be parsed.
export const toInternalPath = (href: string): string => {
  try {
    const u = new URL(href, window.location.origin);
    return `${u.pathname}${u.search}${u.hash}`;
  } catch {
    return href;
  }
};
